var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionHeroBgShapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 411,
    viewBox: "0 0 374 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2398_4345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 380,
    height: 411
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.96 0L0 0L0 410.72L379.96 410.72L379.96 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2398_4345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.62 149.87C590.1 199.35 590.1 279.579 540.62 329.069C508.32 361.359 459.95 373.849 416.04 361.279C390.01 353.829 373.81 337.609 353.11 321.209C290.38 271.499 204.26 224.099 122.95 257.059C99.0605 266.749 123.29 219.529 127.03 212.509C201.19 73.2695 384.47 29.9195 511.9 125C522.06 132.58 531.66 140.9 540.62 149.87Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.401 153.809C579.631 201.039 579.631 277.609 532.401 324.839C501.581 355.669 455.411 367.579 413.501 355.589C388.661 348.479 373.191 332.999 353.441 317.349C293.571 269.899 211.371 224.659 133.761 256.119C110.951 265.359 134.081 220.299 137.651 213.589C208.431 80.6995 383.361 39.3195 504.981 130.069C514.681 137.309 523.841 145.249 532.401 153.799V153.809Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.191 157.749C569.171 202.729 569.171 275.649 524.191 320.619C494.831 349.969 450.871 361.319 410.961 349.899C387.301 343.129 372.581 328.389 353.771 313.479C296.761 268.299 218.481 225.219 144.571 255.169C122.851 263.969 144.881 221.059 148.281 214.669C215.681 88.1194 382.271 48.7194 498.081 135.139C507.311 142.029 516.041 149.589 524.191 157.739V157.749Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.971 161.69C558.691 204.41 558.691 273.68 515.971 316.4C488.091 344.28 446.331 355.06 408.421 344.21C385.951 337.78 371.961 323.78 354.091 309.62C299.941 266.7 225.581 225.78 155.381 254.24C134.751 262.6 155.671 221.84 158.901 215.77C222.931 95.5599 381.161 58.1299 491.171 140.22C499.941 146.76 508.231 153.95 515.971 161.69Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.751 165.63C548.221 206.1 548.221 271.71 507.751 312.18C481.341 338.58 441.781 348.8 405.871 338.52C384.581 332.43 371.331 319.17 354.411 305.75C303.111 265.1 232.681 226.33 166.181 253.29C146.641 261.21 166.461 222.6 169.521 216.85C230.171 102.98 380.051 67.5298 484.261 145.29C492.571 151.49 500.421 158.3 507.751 165.63Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.541 169.57C537.751 207.78 537.751 269.74 499.541 307.95C474.601 332.89 437.241 342.53 403.341 332.83C383.241 327.08 370.731 314.55 354.741 301.89C306.301 263.5 239.791 226.9 177.001 252.35C158.551 259.83 177.261 223.37 180.151 217.94C237.421 110.42 378.961 76.9398 477.361 150.36C485.211 156.21 492.621 162.64 499.541 169.56V169.57Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.321 173.509C527.281 209.469 527.281 267.769 491.321 303.729C467.851 327.199 432.701 336.269 400.791 327.139C381.881 321.729 370.101 309.939 355.061 298.019C309.481 261.889 246.891 227.449 187.801 251.399C170.441 258.439 188.051 224.129 190.771 219.019C244.661 117.839 377.851 86.3292 470.451 155.429C477.831 160.939 484.811 166.989 491.321 173.499V173.509Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.1 177.45C516.81 211.16 516.81 265.8 483.1 299.51C461.1 321.51 428.15 330.01 398.25 321.45C380.52 316.38 369.48 305.33 355.39 294.16C312.67 260.3 254 228.01 198.62 250.46C182.34 257.06 198.85 224.9 201.4 220.11C251.91 125.27 376.75 95.7396 463.55 160.51C470.47 165.67 477.01 171.34 483.12 177.45H483.1Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.891 181.39C506.341 212.84 506.341 263.83 474.891 295.29C454.361 315.82 423.621 323.75 395.711 315.77C379.171 311.03 368.871 300.73 355.711 290.3C315.841 258.7 261.101 228.58 209.421 249.53C194.231 255.69 209.631 225.68 212.011 221.21C259.151 132.71 375.641 105.16 456.621 165.59C463.081 170.41 469.181 175.7 474.881 181.4L474.891 181.39Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.67 185.33C495.87 214.53 495.87 261.87 466.67 291.06C447.61 310.12 419.07 317.48 393.16 310.07C377.8 305.67 368.24 296.11 356.03 286.43C319.02 257.1 268.2 229.13 220.22 248.58C206.12 254.29 220.42 226.44 222.63 222.29C266.39 140.13 374.54 114.55 449.72 170.65C455.71 175.12 461.38 180.03 466.67 185.32V185.33Z",
    stroke: "#ED041D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionHeroBgShapeRed);
export default __webpack_public_path__ + "static/media/solution_hero_bg_shape_red.474b460b3a557145f8f80f0e19a1b831.svg";
export { ForwardRef as ReactComponent };